import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractConsent.List.IRequest;
type Response = Api.Core.ContractConsent.List.IResponse;
type Headers = Api.Core.ContractConsent.List.IHeaders;
const url = '/api/Sales/ContractConsent';
export default async function contractConsentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
